import React from 'react';
import { FlowMetricKey } from '../types/StockData';

interface FlowMetricSelectorProps {
  selectedMetric: FlowMetricKey;
  onMetricChange: (metric: FlowMetricKey) => void;
}

const FlowMetricSelector: React.FC<FlowMetricSelectorProps> = ({ selectedMetric, onMetricChange }) => {
  const metrics = [
    { key: 'volume' as FlowMetricKey, label: 'Volume', description: 'Call vs Put volume comparison' },
    { key: 'premium' as FlowMetricKey, label: 'Premium', description: 'Call vs Put premium comparison' },
    { key: 'trades' as FlowMetricKey, label: 'Trades', description: 'Number of call vs put trades' },
    { key: 'bidAskVolume' as FlowMetricKey, label: 'Bid/Ask Volume', description: 'Bid side vs Ask side volume flow' },
    { key: 'bidAskPremium' as FlowMetricKey, label: 'Bid/Ask Premium', description: 'Bid side vs Ask side premium flow' },
    { key: 'volumeBias' as FlowMetricKey, label: 'Volume Bias', description: 'Net directional volume bias' },
    { key: 'premiumBias' as FlowMetricKey, label: 'Premium Bias', description: 'Net directional premium bias' },
  ];

  return (
    <div className="bg-white rounded-lg shadow-lg p-4 mb-4">
      <h3 className="text-lg font-semibold text-gray-800 mb-3">Flow Metric</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-2">
        {metrics.map((metric) => (
          <button
            key={metric.key}
            onClick={() => onMetricChange(metric.key)}
            className={`p-3 rounded-lg border-2 transition-all duration-200 text-sm ${
              selectedMetric === metric.key
                ? 'border-blue-500 bg-blue-50 text-blue-700'
                : 'border-gray-200 bg-gray-50 text-gray-700 hover:border-blue-300 hover:bg-blue-50'
            }`}
            title={metric.description}
          >
            <div className="font-medium">{metric.label}</div>
          </button>
        ))}
      </div>
      <div className="mt-2 text-sm text-gray-600">
        {metrics.find(m => m.key === selectedMetric)?.description}
      </div>
    </div>
  );
};

export default FlowMetricSelector;
